module.exports = [
    { key: '01', name: '电子健康卡' },
    { key: '1', name: '院内诊疗卡' },
    { key: '2', name: '银医卡' },
    { key: '3', name: '二代身份证' },
    { key: '4', name: '居民健康卡' },
    { key: '5', name: '医保卡' },
    { key: '6', name: '银行卡' },
    { key: '7', name: '佛山健康卡' },
    { key: '8', name: '省医保' },
    { key: '9', name: '市医保' }
]



// WEBPACK FOOTER //
// ./src/config/dict/cardtype.js